<template>
  <div class="BgDetailCard">
    <div class="BgDetailCard__text-container">
      <div
        :class="
          `BgDetailCard__detail-bubble BgDetailCard__detail-bubble--${detail.toLowerCase()}`
        "
      ></div>
      <div class="BgDetailCard__detail">
        {{ detail }}
        <p v-if="insights && insights.length > 0" style="margin-top: 3px;">
          Insight:
          <span v-for="insight in insights" :key="insight">
            <u>{{ insight }} </u><br />
          </span>
        </p>
      </div>
      <div class="BgDetailCard__text">{{ text }}</div>
    </div>
    <div
      v-if="actionIcon"
      @click="
        {
          onClick;
        }
      "
      class="BgDetailCard__action"
    >
      <bg-icon class="BgDetailCard__action__icon" :name="actionIcon" />
      <div class="BgDetailCard__action__text">{{ actionText }}</div>
      <div class="BgDetailCard__action__target">{{ actionTextTarget }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./styles.scss";
</style>

<script>
import BgIcon from "@/components/bg-icon";
export default {
  name: "BgDetailCard",
  components: {
    BgIcon,
  },
  props: {
    text: String,
    detail: String,
    actionText: String,
    actionIcon: String,
    actionTextTarget: String,
    onClick: Function,
    insights: Array,
  },
};
</script>
